import React, { createElement } from 'react'
import Media from './media'
import Container from '../components/container'
import Grid from '../components/grid'

export function BlockMedia({ caption, ...media }) {
  return (
    <figure>
      {(media.image || media.video) && <Media controls {...media} />}
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  )
}

export function BlockText({ text }) {
  return text && <div dangerouslySetInnerHTML={{ __html: text }} />
}

export default function Wysiwyg({ header, content }) {
  const { kicker, heading } = header ?? {}
  const { blocks } = content ?? {}

  return (
    <section className="relative bg-primary standard-spacing">
      <div className="text-center">
        {kicker && <div className="accent-lg">{kicker}</div>}
        {heading && <h2 className="heading-3xl mt-4 mb-12">{heading}</h2>}
      </div>
      <Container className="prose">
        <Grid>
          <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
            {blocks?.length &&
              blocks.map(({ __typename, ...props }, key) => {
                const name = `Block${__typename.split('_').pop()}`

                return createElement(
                  {
                    BlockMedia,
                    BlockText
                  }[name],
                  { key, ...props }
                )
              })}
          </div>
        </Grid>
      </Container>
    </section>
  )
}
